// Formats an integer minor-unit amount (pence) as a display currency string.
// Whole pounds drop trailing .00 (£100); pence keep two decimals (£100.50).
// Extracted from buyerCreditHint so the header credit indicator and the
// reservations card format amounts identically.
export function formatMinorCurrency(minor: number, currency?: string | null): string {
  const pounds = minor / 100;
  const isWholePounds = minor % 100 === 0;
  try {
    // Intl.NumberFormat throws RangeError on an invalid currency code; this runs
    // during render, so a bad ledger row must never crash the page.
    const code = (currency || "gbp").toUpperCase();
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: code,
      minimumFractionDigits: isWholePounds ? 0 : 2,
      maximumFractionDigits: isWholePounds ? 0 : 2,
    }).format(pounds);
  } catch {
    return isWholePounds ? `£${pounds}` : `£${pounds.toFixed(2)}`;
  }
}
